<template>
    <div class="mainLogs">
        <div class="logItems">
            <div class="logMenu">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item
                        ><span @click="changePage()" class="main-menu">
                            更新日志
                        </span>
                    </el-breadcrumb-item>
                    <el-breadcrumb-item>详情</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="tab-menu">
                {{ name }}
            </div>
            <div class="tab-time-menu">
                {{ updateDate }}
            </div>
            <div class="tab-content-menu" v-html="content" v-highlight>
            </div>
            <!-- <el-divider></el-divider> -->
        </div>
    </div>
</template>

<script>
import { Data } from './dataLogDetail';


export default {
    name: 'logDetail',
    data() {
        return {
          name:'',
          updateDate:'',
          logItems: Data,
          content:'',

        };
    },
    methods: {
        changePage() {
            this.$router.push('/devcenter/updateLogs');
        },
    },
    mounted() {
      //日志详情数据渲染
       const id = this.$route.params.id;
       const logContent = this.logItems.updateLog.find((name) => name.id === id);
       this.name = logContent.name;
       this.updateDate = logContent.time;
       this.content = logContent.list;
      
    }
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.mainLogs
  width 60%
  margin 0 auto
.logItems
  width 100%
  margin-left 2.5%
.logMenu
  height 3%
  margin-top 2%

.tab-menu{
  height 5%
  width 100%
  color black
  font-size 1.8rem
  padding-top 28px
  font-weight bold
}

.tab-time-menu{
  color black
  font-size 14px
  padding-top 2%
  padding-bottom 2%
  width 100%
  border-bottom 1px solid #ccc
}

.main-menu
  color: #0c78e2;
  cursor: pointer;
.main-menu:hover
  text-decoration:underline;

.tab-content-menu{
  margin-top 15px
  padding-bottom 25px
  color black
  font-size 14px
  font-size 1.1rem
  width 100%
}
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/updateLogs/logDetail.vue